// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2bodF","image":"Header_image__1TjKT","name":"Header_name__1LoPk","info":"Header_info__1q56T","infoRow":"Header_infoRow__3s25T"};